module.exports = __webpack_public_path__ + "bd77b0e3ede5258d4fefc53929c2cf4f.svg";